import script from "./StatisticTablePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./StatisticTablePage.vue?vue&type=script&setup=true&lang=ts"

import "./StatisticTablePage.vue?vue&type=style&index=0&id=0d9b2940&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d9b2940"]])

export default __exports__